// Utilitário para converter PascalCase e snake_case para camelCase
export function toCamelCase(str: string): string {
  // Handle snake_case → camelCase (e.g., criado_em → criadoEm, email_sent → emailSent)
  const snakeToCamel = str.replace(/_([a-z0-9])/g, (_, letter) => letter.toUpperCase());
  // Handle PascalCase → camelCase (e.g., ClienteName → clienteName)
  return snakeToCamel.charAt(0).toLowerCase() + snakeToCamel.slice(1);
}

export function keysToCamel(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(v => keysToCamel(v));
  } else if (obj !== null && obj.constructor === Object) {
    return Object.keys(obj).reduce((acc, key) => {
      const camelKey = toCamelCase(key);
      acc[camelKey] = keysToCamel(obj[key]);
      return acc;
    }, {} as any);
  }
  return obj;
}
